export const _ADD       = "4nwFfuKQ/MYkQ4hA+JVCJprMg2ITIxI3UKyaUWscBlY=";
export const _EDIT      = "g99Xi3UJCcnWRnGYgGAeZ6Xr+E70Mv0Omt+749D2XoQ=";
export const _VIEW      = "er+gRE0bjpD9kPnIBgbgRIIkUIiGNRQVWrnmUEwzO8E=";
export const _DELETE    = "8AU6e3k8EUVOk3dQWSRowUIIIb8Iygzz20UlDAuxACg=";
export const _RECOVER   = "xBeZIPhkipLYMXFEoz6E1And8Ps3ZRO9RFVTvL41cc8=";
export const _LIST      = "/SDnzTnZLYp33hszbCjP5GGChnLkY3ZXCHZzAS1eFs4=";
export const _TRASH     = "jDQYVCMawCuRBhzWCuq2YF8gLDjaXEDwXUpgtCmRyoU=";